export const obtenerFractales = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/fractales`);
    return response.json();
  };
  
  export const crearFractal = async (fractal) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/fractales`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fractal),
    });
    return response.json();
  };
  